import {onPageReady} from '../loader/script-loader-helper.js';

onPageReady(() => {
    const disclosureTargets = Array.from(document.querySelectorAll('.js-disclosure-target'));
    for (const disclosureTarget of disclosureTargets) {
        disclosureTarget.addEventListener('command', event => {
            switch (event.command) {
                case '--disclosure-toggle': {
                    const currentStatus = disclosureTarget.getAttribute('aria-expanded') ?? 'false';
                    disclosureTarget.setAttribute('aria-expanded', currentStatus === 'false' ? 'true' : 'false');
                    break;
                }
                case '--disclosure-open': {
                    disclosureTarget.setAttribute('aria-expanded', 'true');
                    break;
                }
                case '--disclosure-close': {
                    disclosureTarget.setAttribute('aria-expanded', 'false');
                    break;
                }
            }
        });
    }
});
